/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductObjectCreatePage = lazyLoad(
  () => import('./index'),
  module => module.ProductObjectCreatePage
);
